export default __webpack_public_path__ + "static/Elson-269e2d2671cfac411e2cb99c167b10f9.webp";